import * as Caml_option from "bs-platform/lib/es6/caml_option.js";
import * as ScienceJs from "./science.js";
import * as Science0$SolvuuApi from "./science0.bs.js";

function categoricalSeriesToHistogram(prim) {
  return ScienceJs.categoricalSeriesToHistogram(prim);
}

function numericSeriesToKernelDensity(prim) {
  return ScienceJs.numericSeriesToKernelDensity(prim);
}

function normalizeMatrix(prim) {
  return ScienceJs.normalizeMatrix(prim);
}

function transposeMatrix(prim) {
  return ScienceJs.transposeMatrix(prim);
}

var meanLinkage = ScienceJs.meanLinkage;
var singleLinkage = ScienceJs.singleLinkage;
var completeLinkage = ScienceJs.completeLinkage;
var centroidLinkage = ScienceJs.centroidLinkage;
var wardLinkage = ScienceJs.wardLinkage;
var euclideanDistance = ScienceJs.euclideanDistance;
var manhattanDistance = ScienceJs.manhattanDistance;
var maximumDistance = ScienceJs.maximumDistance;
var pearsonCorrelationDistance = ScienceJs.pearsonCorrelationDistance;
var spearmanCorrelationDistance = ScienceJs.spearmanCorrelationDistance;
var kendallCorrelationDistance = ScienceJs.kendallCorrelationDistance;

function hierarchicalClustering(prim, prim$1, prim$2, prim$3) {
  return ScienceJs.hierarchicalClustering(prim, prim$1, prim$2, prim$3);
}

function kMeansClustering(prim, prim$1, prim$2, prim$3) {
  return ScienceJs.kMeansClustering(prim, prim$1, prim$2, prim$3);
}

function pearsonCorrelationCoefficient(prim, prim$1) {
  return Caml_option.nullable_to_opt(ScienceJs.pearsonCorrelationCoefficient(prim, prim$1));
}

function calculatePCoA(prim, prim$1) {
  return ScienceJs.calculatePCoA(prim, prim$1);
}

function calculatePercentiles(prim) {
  return ScienceJs.calculatePercentiles(prim);
}

var normalDistributionPercentiles = ScienceJs.normalDistributionPercentiles;
var minusLog10UniformDistributionPercentiles = ScienceJs.minusLog10UniformDistributionPercentiles;
var log2UniformDistributionPercentiles = ScienceJs.log2UniformDistributionPercentiles;
var concordant = Science0$SolvuuApi.concordant;
var discordant = Science0$SolvuuApi.discordant;
var kendall_tau = Science0$SolvuuApi.kendall_tau;
export { concordant, discordant, kendall_tau, categoricalSeriesToHistogram, numericSeriesToKernelDensity, normalizeMatrix, transposeMatrix, meanLinkage, singleLinkage, completeLinkage, centroidLinkage, wardLinkage, euclideanDistance, manhattanDistance, maximumDistance, pearsonCorrelationDistance, spearmanCorrelationDistance, kendallCorrelationDistance, hierarchicalClustering, kMeansClustering, pearsonCorrelationCoefficient, calculatePCoA, calculatePercentiles, normalDistributionPercentiles, minusLog10UniformDistributionPercentiles, log2UniformDistributionPercentiles };
/* meanLinkage Not a pure module */